import { getContext } from '@fiverr-private/fiverr_context';

export const loyaltyPopoverOpenParams = ({ sellerId, sellerName }) => ({
    'Seller Id': sellerId,
    'Seller Name': sellerName
});

// This is a temp file that will be migrated, once the WithImpressions will utilze the Impressionable package.
export const loyaltyBigQueryParams = ({ sellerId, sellerName }) => {
    const { pageCtxId, userGuid, userId, isMobile } = getContext();
    const platform = isMobile ? 'mobile_web' : 'web';

    return {
        type: 'returning_buyers_banner',
        sub_group: 'content_impression',
        group: 'user_impressions',
        action: { type: 'impression' },
        domain: { name: 'quality' },
        publisher: {
            domain: 'algos',
            sub_domain: 'quality'
        },
        feature: {
            name: 'loyalty_program'
        },
        page: {
            name: 'user_page',
            ctx_id: pageCtxId,
            element: {
                name: 'loyalty_banner',
                type: 'text',
                text: 'buyers keep returning'
            }
        },
        out_of_session: false,
        platform,
        uid: userGuid,
        user: { id: userId },
        seller: { id: sellerId, username: sellerName }
    };
};
